import { TourConfig } from '../models/tour-config.model';
import { TourFeature } from '../config/tour-feature.enum';
import { Audience } from '../config/audience.enum';
import { TourTrigger } from '../config/trigger.enum';
import { AnchorId } from '../config/anchor.registry';

/**
 * "Mehr entdecken", Teil 1 von 3 — freiwillige Zusatz-Station der Demo-Quick-
 * Tour (`demo-quick-tour.config.ts`), verkettet ueber Station 3 (`actions[].
 * startTour`). Zeigt die Mitarbeiterverwaltung, endet mit einem Weiter zur
 * Zeiterfassung (`DemoDiscoverTimeRecording`).
 *
 * Live-Feedback 10.09.2026: die Haupttour zeigte nie, dass ein Mitarbeiter
 * mehr ist als eine Planungs-Ressource — Einladen, Berechtigungen, Urlaubs-
 * Kontingent liegen alle im ⋮-Menue derselben Zeile. Anker + Menuepunkte
 * verifiziert gegen `employee-advanced-table.component.html` (Invite-Zeile,
 * Berechtigungen nur bei Role===3, Urlaub verwalten, PIN zuruecksetzen,
 * Aktiv/Inaktiv, Audit-Trail, Loeschen) — keiner davon erfunden.
 */
export const DEMO_DISCOVER_EMPLOYEE: TourConfig = {
  id: TourFeature.DemoDiscoverEmployee,
  version: 1,
  title: 'TUTORIAL.DEMO_DISCOVER_EMPLOYEE.TITLE',
  description: 'TUTORIAL.DEMO_DISCOVER_EMPLOYEE.DESCRIPTION',
  audience: [Audience.Admin, Audience.TeamLeader],
  triggers: [TourTrigger.Manual],
  launchContext: {
    route: '/employee',
  },
  statePolicy: {
    allowReplay: false,
    snoozeEnabled: false,
    cooldownHoursAfterDismiss: 0,
    cooldownHoursAfterSnooze: 0,
    suppressAfterCompletion: true,
  },
  priority: 5,
  estimatedDurationSec: 15,
  category: 'feature-discovery',
  chapters: [
    {
      id: 'demo-discover-employee',
      title: 'TUTORIAL.DEMO_DISCOVER_EMPLOYEE.TITLE',
      steps: [
        {
          id: 'employee-management',
          anchor: AnchorId.EmployeeTable,
          spotlightAnchor: AnchorId.EmployeeTable,
          additionalSpotlightAnchors: [AnchorId.EmployeeActionsMenu],
          title: 'TUTORIAL.DEMO_DISCOVER_EMPLOYEE.STATION.TITLE',
          content: 'TUTORIAL.DEMO_DISCOVER_EMPLOYEE.STATION.CONTENT',
          placement: 'bottom',
          nextCondition: 'manual',
          showNextButton: false,
          showPrevButton: false,
          showSkipButton: true,
          actions: [
            {
              labelKey:
                'TUTORIAL.DEMO_DISCOVER_EMPLOYEE.DISCOVER_TIME_RECORDING_CTA',
              variant: 'primary',
              startTour: TourFeature.DemoDiscoverTimeRecording,
            },
          ],
        },
      ],
    },
  ],
};
